/** @format */

import React, { FunctionComponent, ReactElement, SyntheticEvent } from 'react';
import MvnoBlockApiRequest from '../../../interfaces/platform/MvnoBlockApiRequest';
import { TableCell, TableRow } from '@material-ui/core';
import ViewButton from '../../../components/Buttons/ViewButton';
import SimCardButton from '../../../components/Buttons/SimCardButton';
import ApiUri from '../../../interfaces/api/ApiUri';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { history } from '../../../core/history';
import I18n from '../../../components/Translate/I18n';
import { ApiOperationStateHelper } from '../../lib/search/ApiOperationStateHelper';
import { DateHelper } from '../../../helpers/DateHelper';
import { ApiRestViewDetail } from './ApiRestViewDetail';
import MvnoBlockListInterface from '../../../interfaces/platform/MvnoBlockListInterface';
import { MvnoBlockListCollectionInterface } from '../../../interfaces/collections/MvnoBlockListCollectionInterface';

const _ = require('underscore');

export type ApiListRestItenType = {
    classes: any;
    item: MvnoBlockApiRequest;
    viewDialog(title: any | string | null, content: any | null): void;
    setActiveRow: (id: number) => void;
    rowActiveColor: string;
    mvnoBlockList: MvnoBlockListCollectionInterface | null;
};

export const ApiListRestItem: FunctionComponent<ApiListRestItenType> = ({
    classes,
    item,
    viewDialog,
    setActiveRow,
    rowActiveColor,
    mvnoBlockList,
}) => {
    const tableCellRoot = { root: classes.tableCellRootBordered };
    const tableRowRoot = { root: classes.tableRowRoot };
    const tableStickyCommand = { root: classes.tableStickyCommand };

    const callViewDetail = (item: MvnoBlockApiRequest): void => {
        const title = <I18n trans="prov:h.api_operation_type_rest" valueObject={{ method: item.apiCommand }} />;
        viewDialog(title, <ApiRestViewDetail classes={classes} item={item} />);
    };

    const callViewSimCard = (params: ApiUri, event?: SyntheticEvent): void => {
        const uri = FormGeneralHelper.getRouteUrl('/sim-card-edit' + params.uri);
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        history.respectModifierPush(event, uri);
    };

    const getCorrectMvnoBlockItem = (id: number): string => {
        console.log(mvnoBlockList);
        let correctValue = '';

        if (mvnoBlockList) {
            mvnoBlockList['hydra:member'].forEach((el: MvnoBlockListInterface) => {
                console.log(id, el);
                if (id === el.id) {
                    correctValue = el.blockName;
                }
            });
        }

        return correctValue;
    };

    const splitTextShort = (str: string): string => {
        return str;
        // return str.replace(
        //     /\/adescom-api\/api\/platform\/|\/base-api\/api\/platform\/|\/adescom-api\/api\/billing\/|\/base-api\/api\/billing\//g,
        //     ''
        // );
    };

    const splitTextLongGet = (str: string): ReactElement => {
        const [beforeAmpersand, afterAmpersand] = splitTextShort(str).split(/&(.*)/s);
        if (!afterAmpersand || afterAmpersand.length < 1) {
            return <>{beforeAmpersand}</>;
        }
        return (
            <>
                {beforeAmpersand}
                <br />&{afterAmpersand}
            </>
        );
    };

    return (
        <TableRow
            key={'key' + item.id}
            onClick={(): void => {
                setActiveRow(item.id);
            }}
            classes={tableRowRoot}
            style={{ backgroundColor: rowActiveColor }}
            hover
        >
            <TableCell classes={tableStickyCommand} padding="none" align="left">
                <ViewButton
                    callback={callViewDetail}
                    tooltipTitle="prov:list.view"
                    tooltipPlacement="bottom-start"
                    callbackParam={item}
                    key={'detail' + item.id}
                />
                {item.simCard && (
                    <SimCardButton
                        callback={callViewSimCard}
                        tooltipTitle="prov:list.msisdn_view"
                        tooltipPlacement="bottom-start"
                        callbackParam={{ uri: item.simCard }}
                        key={'simcard' + item.id}
                    />
                )}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="left">
                {item.id}
            </TableCell>
            {/*{(Auth.isAdminMode() || Auth.isAdminExpertMode()) && (*/}
            <TableCell classes={tableCellRoot} padding="none" align="center">
                {item.platformResellerName}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="center">
                {item.platformUserName}
            </TableCell>
            {/*)}*/}
            <TableCell classes={tableCellRoot} padding="none" align="center">
                {item.mvnoBlockListId && <I18n trans={getCorrectMvnoBlockItem(item.mvnoBlockListId)} />}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="center">
                {item.apiCommand}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="center">
                {item.msisdn}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="center">
                {item.imsi}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="center">
                {item.method !== 'GET' || (item.apiIri && item.apiIri.length < 70)
                    ? splitTextShort(item.apiIri ?? '')
                    : splitTextLongGet(item.apiIri ?? '')}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="center">
                <I18n trans={ApiOperationStateHelper.getStateName(item.apiState)} />
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="center">
                {DateHelper.format(item.startProcessAt)}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="center">
                {DateHelper.format(item.stopProcessAt)}
            </TableCell>
        </TableRow>
    );
};
